import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex } from '@chakra-ui/react';
import { formatDataTestId, renderSanitizedHtml } from '@whitbread-eos/utils';
import React from 'react';
import { Info } from '../../assets/icons';
import Icon from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DonationsInfoBox(_ref) {
  var informationBox = _ref.informationBox;
  var baseDataTestId = 'Donation';
  return _jsxs(Flex, _objectSpread(_objectSpread({}, donationInfoBoxStyle), {}, {
    "data-testid": formatDataTestId(baseDataTestId, 'InfoBox'),
    children: [_jsx(Box, {
      pr: "sm",
      "data-testid": formatDataTestId(baseDataTestId, 'InfoBoxIcon'),
      children: _jsx(Icon, {
        svg: _jsx(Info, {})
      })
    }), _jsx(Box, _objectSpread(_objectSpread({}, donationInfoBoxTextStyle), {}, {
      "data-testid": formatDataTestId(baseDataTestId, 'InfoBoxText'),
      className: "formatLinks",
      children: renderSanitizedHtml(informationBox)
    }))]
  }));
}
var donationInfoBoxStyle = {
  border: '1px solid var(--chakra-colors-lightGrey2)',
  borderRadius: 'var(--chakra-space-xs)',
  p: 'md',
  w: {
    mobile: 'full',
    md: '45rem',
    lg: '50.5rem',
    xl: '54rem'
  },
  mt: 'xl'
};
var donationInfoBoxTextStyle = {
  fontSize: 'sm',
  fontWeight: 'normal'
};